import React, { useState } from "react";
import AuthService from "../../service/authService";
import { Link } from "react-router-dom";
import "../ResetPassword/resetPassword.scss";
import { useTranslation } from "react-i18next";

const UpdatePassword = (props) => {
  const { t } = useTranslation();

  const { match } = props;

  const [isPasswordUpdated, setIsPasswordUpdated] = useState(false);
  const [password, setPassword] = useState();
  const [errorMsg, setErrorMsg] = useState();

  const onClickReset = (e) => {
    e.preventDefault();
    const data = { password: password };
    const token = match.params.token;

    AuthService.updatePassword(data, token)
      .then((res) => {
        if (res.data.status === "success") {
          setIsPasswordUpdated(true);
        }
      })
      .catch(() => {
        setErrorMsg(t("forgot_password.expired_link"));
      });
  };

  return (
    <React.Fragment>
      <div className="reset-pword-wrap">
        {!isPasswordUpdated ? (
          <div>
            <p>{t("forgot_password.update_password")}</p>
            <form onSubmit={(e) => onClickReset(e)}>
              <div className="form-group">
                <input
                  type="password"
                  className="form-control"
                  required
                  placeholder={t("forgot_password.password_placeholder")}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              {errorMsg && (
                <div>
                  <Link to="/login">{t("forgot_password.back_login")}</Link>
                  <div className="error">{errorMsg}</div>
                </div>
              )}
              <button
                type="submit"
                className="btn btn-submit btn-primary"
                variant="primary"
              >
                {t("forgot_password.update_button")}
              </button>
            </form>
          </div>
        ) : (
          <div>
            {t("forgot_password.login_with_new_password")}{" "}
            <Link to="/login">{t("forgot_password.back_login")}</Link>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default UpdatePassword;
